import React from "react";
import { motion } from "framer-motion";
import { Calendar, Palette, Sparkles, Wand2 } from "lucide-react";

const OutfitForm = ({ formData, handleInputChange, generateOutfit, isLoading }) => (
    <form className="w-full space-y-4">
        <div>
            <label className="flex items-center space-x-2 text-gray-700 text-sm font-medium mb-3">
                <Calendar className="w-4 h-4" />
                <span>Occasion</span>
            </label>
            <select
                name="occasion"
                value={formData.occasion}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all bg-white"
            >
                <option value="">Toute occasion</option>
                <option value="casual">Casual</option>
                <option value="formel">Formel</option>
                <option value="soirée">Soirée</option>
            </select>
        </div>

        <div>
            <label className="flex items-center space-x-2 text-gray-700 text-sm font-medium mb-3">
                <Sparkles className="w-4 h-4" />
                <span>Style préféré</span>
            </label>
            <select
                name="style"
                value={formData.style}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all bg-white"
            >
                <option value="chic">Chic</option>
                <option value="décontracté">Décontracté</option>
                <option value="sport">Sport</option>
            </select>
        </div>

        <div>
            <label className="flex items-center space-x-2 text-gray-700 text-sm font-medium mb-3">
                <Calendar className="w-4 h-4" />
                <span>Saison *</span>
            </label>
            <select
                name="season"
                value={formData.season}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all bg-white"
            >
                <option value="ete">Été</option>
                <option value="hiver">Hiver</option>
                <option value="printemps">Printemps</option>
                <option value="automne">Automne</option>
            </select>
        </div>

        <div>
            <label className="flex items-center space-x-2 text-gray-700 text-sm font-medium mb-3">
                <Palette className="w-4 h-4" />
                <span>Couleur souhaitée</span>
            </label>
            <select
                name="color"
                value={formData.color}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all bg-white"
            >
                <option value="">Aucune préférence</option>
                <option value="bleu">Bleu</option>
                <option value="noir">Noir</option>
                <option value="blanc">Blanc</option>
                <option value="rouge">Rouge</option>
                <option value="vert">Vert</option>
            </select>
        </div>

        <motion.button
            type="button"
            onClick={generateOutfit}
            disabled={isLoading}
            whileHover={{ scale: isLoading ? 1 : 1.02 }}
            whileTap={{ scale: isLoading ? 1 : 0.98 }}
            className="w-full flex items-center justify-center space-x-2 text-white font-medium px-6 py-4 rounded-xl shadow-soft transition-all disabled:opacity-50 disabled:cursor-not-allowed bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700"
        >
            {isLoading ? (
                <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    <span>Génération en cours...</span>
                </>
            ) : (
                <>
                    <Wand2 className="w-5 h-5" />
                    <span>Générer avec l'IA</span>
                </>
            )}
        </motion.button>
    </form>
);

export default OutfitForm;
